// Use binary types so we can have more than one per notification.
// i.e. { type: notificationType.SOUND + notificationType.TOAST }

export default Object.freeze({
    SOUND: 1, //0b0001,
    TOAST: 2, //0b0010,
    LIST: 4, //0b0100,
    SYNC_BUSY: 8 //0b1000
});
